import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/company_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.name',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'jushuitan_supplier_id': { required: false, disabledUpdate: false },
    'merchandiser_ids': { required: false, disabledUpdate: false },
    'order_limit': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Company', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Company', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
